var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { avoidAuthToken } from "@adapters/constants";
import MutualFundsConfigURL from "@adapters/infrastructures/urlConfig/Markets/mutualFundsURL";
import ExploreFundsMapper from "@domains/features/Markets/MutualFunds/mapper/ExploreFundsMapper";
import { FundsHouseMapper } from "@domains/features/Markets/MutualFunds/mapper/FundsHouseMapper";
import { MutualFundsSchemesMapper } from "@domains/features/Markets/MutualFunds/mapper/MutualFundsSchemesMapper";
import { removeEmptyKeyValuesPairs } from "@domains/utils/validation";
import SchemeCategoryMapper from "@domains/features/Markets/MutualFunds/mapper/MFSchemeCategoryMapper";
import { accountDetails } from "@salesdi";
import { EUserRole } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IGetMFOrderbookSummaryEntity";
var MutualFundsRepository = /** @class */ (function () {
    function MutualFundsRepository(http) {
        this.http = http;
    }
    MutualFundsRepository.prototype.getFilters = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var reqObj, url, mutualFundsSchemes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqObj = removeEmptyKeyValuesPairs(request);
                        url = new URL(MutualFundsConfigURL.filterData);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: reqObj,
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        mutualFundsSchemes = _a.sent();
                        return [2 /*return*/, mutualFundsSchemes];
                }
            });
        });
    };
    MutualFundsRepository.prototype.exploreFunds = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, exploreFunds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(MutualFundsConfigURL.exploreFunds);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        exploreFunds = _a.sent();
                        //   const exploreFunds = JSON.parse(dummyExploreFunds);
                        return [2 /*return*/, ExploreFundsMapper(exploreFunds.data)];
                }
            });
        });
    };
    MutualFundsRepository.prototype.getMutualFundCategory = function (request) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, _request, loginType, res;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(MutualFundsConfigURL.getMutualFundCategory);
                        _request = __assign({}, request);
                        delete _request.skipFilters;
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 1:
                        loginType = _c.sent();
                        if (loginType && loginType === EUserRole.PARTNER) {
                            // send type only in the case of partner login.
                            loginType && url.searchParams.append("loginType", loginType);
                        }
                        if (((_a = _request === null || _request === void 0 ? void 0 : _request.removeCategoryCodes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url.searchParams.append("removeCategoryCodes", (_b = _request.removeCategoryCodes) === null || _b === void 0 ? void 0 : _b.toString());
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 2:
                        res = _c.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    MutualFundsRepository.prototype.getMutualFundsSchemes = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var url, mutualFundsSchemes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(MutualFundsConfigURL.getMutualFundsSchemes);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: request,
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        mutualFundsSchemes = _a.sent();
                        // if (request.limit) {
                        //   mutualFundsSchemes.data.mutualFundSummary =
                        //     mutualFundsSchemes.data.mutualFundSummary.splice(0, request.limit);
                        // }
                        //const mutualFundsSchemes = JSON.parse(dummyMutualFundsSchemes);
                        return [2 /*return*/, MutualFundsSchemesMapper(mutualFundsSchemes, Number(request.pageSize))];
                }
            });
        });
    };
    MutualFundsRepository.prototype.getFundHouses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, mutualFundHouses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(MutualFundsConfigURL.fundsHouse);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        mutualFundHouses = _a.sent();
                        //const mutualFundHouses = JSON.parse(dummyMutualFundsHouse);
                        return [2 /*return*/, FundsHouseMapper(mutualFundHouses.data.amcFundsObjectList)];
                }
            });
        });
    };
    MutualFundsRepository.prototype.getSchemeCategory = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, schemeCategory;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(MutualFundsConfigURL.schemeCategory);
                        url.searchParams.append("categoryCode", req.selectedCategory);
                        if (req === null || req === void 0 ? void 0 : req.platformType)
                            url.searchParams.append("src", req.platformType);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        schemeCategory = _a.sent();
                        return [2 /*return*/, SchemeCategoryMapper(schemeCategory)];
                }
            });
        });
    };
    MutualFundsRepository.prototype.mFPurchaseSipCta = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(MutualFundsConfigURL.mFPurchaseSipCta);
                        url.searchParams.append("schemeCode", req.schemeCode);
                        req.searchText && url.searchParams.append("searchText", req.searchText);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return MutualFundsRepository;
}());
export default MutualFundsRepository;
